import script from "./CompletedEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompletedEdit.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__